export const colors = {
  palmNetwork: {
    100: "#171717",
    200: "#F5F5F5",
    300: "#d49cff",
    400: "#4a1e1f",
    500: "#6234df",
    600: "#957c20",
    700: "#4d4d4d", // info
    800: "#ff9900", // warning
    900: "#cc0000", // error
    1000: "#00b300", // success
  },
  palmNetworkLight: {
    100: "#d3d3d3",
    200: "#fafafa",
    300: "#e6ccff",
    400: "#ffd6e6",
    500: "#c2d6d6",
    600: "#fff0b3",
  },
  brand: {
    100: "#3A3A3A",
    200: "#595959",
    300: "#6C6C6C",
    400: "#949494",
    500: "#B4B4B4",
    600: "#DBDBDB",
    700: "#E8E8E8",
    800: "#1A1A1A",
    900: "#F2F3F1",
  },
  gray: {
    "50": "#F3F4F1",
    "100": "#DCE0D7",
    "200": "#C6CCBD",
    "300": "#AFB7A3",
    "400": "#99A38A",
    "500": "#838F70",
    "600": "#68725A",
    "700": "#4E5643",
    "800": "#34392D",
    "900": "#1A1D16",
  },
  blue: {
    "50": "#EBF1FA",
    "100": "#C7D7F0",
    "200": "#A2BEE6",
    "300": "#7EA4DD",
    "400": "#5A8AD3",
    "500": "#3671C9",
    "600": "#2B5AA1",
    "700": "#204479",
    "800": "#162D50",
    "900": "#0B1728",
  },
  purple: {
    "50": "#F3ECF8",
    "100": "#DCCBEC",
    "200": "#C6A9DF",
    "300": "#B088D3",
    "400": "#9966C6",
    "500": "#8345BA",
    "600": "#693795",
    "700": "#4F2970",
    "800": "#341C4A",
    "900": "#1A0E25",
  },
  pink: {
    "50": "#F8ECF2",
    "100": "#ECCBD9",
    "200": "#E0A9C1",
    "300": "#D487A9",
    "400": "#C76591",
    "500": "#BB4479",
    "600": "#963661",
    "700": "#702949",
    "800": "#4B1B30",
    "900": "#250E18",
  },
  red: {
    "50": "#FCEAE8",
    "100": "#F7C4BF",
    "200": "#F39E96",
    "300": "#EE786D",
    "400": "#E95244",
    "500": "#E42C1B",
    "600": "#B62316",
    "700": "#891A10",
    "800": "#5B120B",
    "900": "#2E0905",
  },
  orange: {
    "50": "#FDF3E7",
    "100": "#FADEBD",
    "200": "#F7C892",
    "300": "#F3B367",
    "400": "#F09D3D",
    "500": "#ED8812",
    "600": "#BD6D0F",
    "700": "#8E520B",
    "800": "#5F3607",
    "900": "#2F1B04",
  },
  yellow: {
    "50": "#FEFAE7",
    "100": "#FCF2BB",
    "200": "#FAE98F",
    "300": "#F7E163",
    "400": "#F5D838",
    "500": "#F3D00C",
    "600": "#C3A609",
    "700": "#927D07",
    "800": "#615305",
    "900": "#312A02",
  },
  green: {
    "50": "#F3F8EC",
    "100": "#DDEDCA",
    "200": "#C8E1A8",
    "300": "#B2D586",
    "400": "#9CC964",
    "500": "#87BD42",
    "600": "#6C9735",
    "700": "#517128",
    "800": "#364C1A",
    "900": "#1B260D",
  },
  teal: {
    "50": "#ECF7F8",
    "100": "#CBEAEB",
    "200": "#AADCDF",
    "300": "#88CFD2",
    "400": "#67C1C6",
    "500": "#46B3B9",
    "600": "#389094",
    "700": "#2A6C6F",
    "800": "#1C484A",
    "900": "#0E2425",
  },
  cyan: {
    "50": "#EFF5F6",
    "100": "#D2E3E5",
    "200": "#B5D1D4",
    "300": "#98BFC3",
    "400": "#7BADB2",
    "500": "#5E9BA1",
    "600": "#4B7C81",
    "700": "#385D61",
    "800": "#253E41",
    "900": "#131F20",
  },
};
